import { gql } from '@apollo/client'

export const modelAttachmentMarkupsQuery = gql`
    query quoteModelRevisionAttachmentMarkups($id: UUID!) {
        quoteModelRevision(id: $id) {
            id
            attachmentLink {
                id
                quoteAttachmentRevision {
                    id
                    attachment {
                        ... on Attachment {
                            id
                            downloadUrl
                            fileName
                            annotated {
                                id
                                fileName
                                downloadUrl
                            }
                            modelAttachmentSelections {
                                id
                                documentPage
                                positionX
                                positionY
                                height
                                width
                                text
                                modelAttachmentAnnotation {
                                    id
                                    positionX
                                    positionY
                                    documentPage
                                    radius
                                    label
                                }
                            }
                            modelAttachmentSanitizations {
                                id
                                documentPage
                                positionX
                                positionY
                                height
                                width
                            }
                        }
                    }
                }
            }
        }
    }
`

export const createSanitizedAttachmentMutation = gql`
    mutation createSanitizedAttachmentBubbleDrawing(
        $attachmentId: UUID!
        $uploadMetadata: AttachmentInput!
        $quoteModelRevisionId: UUID
    ) {
        createSanitizedAttachment(
            attachmentId: $attachmentId
            uploadMetadata: $uploadMetadata
            quoteModelRevisionId: $quoteModelRevisionId
        ) {
            id
            uploadUrl
        }
    }
`

export const markUploadedSanitizedAttachmentMutation = gql`
    mutation markUploadedSanitizedAttachmentBubbleDrawing($id: UUID!) {
        markUploadedSanitizedAttachment(id: $id) {
            id
        }
    }
`

export const calloutLabelsQuery = gql`
    query quoteModelRevisionCalloutLabels($id: UUID!) {
        quoteModelRevision(id: $id) {
            id
            attachmentLink {
                id
                quoteAttachmentRevision {
                    id
                    attachment {
                        ... on Attachment {
                            id
                            modelAttachmentSelections {
                                id
                                userAnnotationsId
                                modelAttachmentAnnotation {
                                    id
                                    label
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
